// 品牌常數（前端側）——compose（theme.mjs）依 customer.json 重寫本檔各常數值。
// 代碼一律 import { SITE_NAME } from '../lib/brand'，不得硬編碼品牌字串。

// @branding:brandName
export const SITE_NAME = 'YYC 直播試貨平台';

// 落單關鍵字品牌前綴（ WhatsApp 訊息「<SENDER_KEYWORD>落單 ORDER:xxx」用；
// server 端 ORDER_KEYWORD_BRANDS 含同名，兩端對齊才 match）
// @branding:senderKeyword
export const SENDER_KEYWORD = 'YYC平台';

// @branding:brandTagline
export const SITE_TAGLINE = '香港品牌 · 直播試貨 · 包稅直郵';

// @branding:whatsappNumber
export const WHATSAPP_NUMBER = '85200000000';
